import { call, put, select, take, takeLatest } from 'redux-saga/effects';

import { SELECT_DEALER } from 'constants/ActionTypes';
import { PATH } from 'constants/RoutesConstants';
import { scopeToPage } from 'modules/app/sagas/utils';
import type { MayBe } from 'modules/global/typing/common/common';
import { FETCH_GROUP_FAILURE, FETCH_GROUP_SUCCESS, SELECT_GROUP } from 'modules/groups/actionTypes';
import { getSelectedGroupId } from 'modules/groups/selectors';
import { fetchPublicTokens } from 'modules/publicToken/actions';
import { PUBLIC_TOKEN } from 'modules/publicToken/constants';
import { getPublicTokenDashboardTarget } from 'modules/publicToken/selectors';
import type { PublicTokenDashboardTarget } from 'modules/publicToken/types';

function* refreshPublicTokenDashboard() {
  const params: PublicTokenDashboardTarget = yield select(getPublicTokenDashboardTarget);
  yield put(fetchPublicTokens(params, { source: PUBLIC_TOKEN }));
}

function* onDealerPageWorker() {
  yield call(refreshPublicTokenDashboard);
  yield takeLatest(SELECT_DEALER, refreshPublicTokenDashboard);
}

function* onGroupPageWorker() {
  // Initial wait for group to be loaded
  const groupId: MayBe<string> = yield select(getSelectedGroupId);
  if (!groupId) {
    yield take([FETCH_GROUP_SUCCESS, FETCH_GROUP_FAILURE]);
  }

  yield call(refreshPublicTokenDashboard);
  yield takeLatest(SELECT_GROUP, refreshPublicTokenDashboard);
}

export default function* publicTokenDashboardSaga() {
  yield scopeToPage([PATH.GROUP_PUBLIC_TOKENS_DASHBOARD], onGroupPageWorker);
  yield scopeToPage([PATH.DEALER_PUBLIC_TOKENS_DASHBOARD], onDealerPageWorker);
}
